import { REMINDER_CHANNELS } from '@src/shared/types/reminder';
import type { TReminderPerformanceMonth } from '@src/features/reminders/services/reminder-api';

function getMonthOrder(monthLabel: string): number {
  const parsed = new Date(`${monthLabel} 1, 2000`);
  if (!Number.isNaN(parsed.getTime())) return parsed.getMonth();
  return Number.MAX_SAFE_INTEGER;
}

export function applyChannelMaskToPerformance(
  data: TReminderPerformanceMonth[] | undefined,
  selected: string[]
): TReminderPerformanceMonth[] {
  if (!data?.length) return [];
  const masked =
    selected.length === 0
      ? [...data]
      : data.map((item) => ({
          ...item,
          whatsapp: selected.includes(REMINDER_CHANNELS.whatsapp)
            ? item.whatsapp
            : 0,
          email: selected.includes(REMINDER_CHANNELS.email) ? item.email : 0,
          sms: selected.includes(REMINDER_CHANNELS.sms) ? item.sms : 0,
        }));

  return masked.sort(
    (a, b) => getMonthOrder(a.month) - getMonthOrder(b.month)
  );
}
